module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [(_vm.isLogin) ? _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#header_collapse",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _c('span', [_vm._v("メニュー")]), (_vm.noticeCount > 0 || _vm.introductionNoticeCount > 0) ? _c('span', {
    staticClass: "badge",
    staticStyle: {
      "background-color": "red"
    }
  }, [_vm._v(_vm._s(_vm.noticeCount + _vm.introductionNoticeCount))]) : _vm._e()]) : _vm._e(), _c('router-link', {
    staticClass: "navbar-bland",
    attrs: {
      "to": "/"
    }
  }, [(_vm.isStaging) ? _c('h1', [_vm._v("！！！テスト環境です！！！")]) : _c('h1', [_vm._v("Taira Best Innovation")])])], 1), (_vm.isLogin) ? _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "header_collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.clearSessionStrage()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/safety_confirmations"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Safety Confirmation')))])])], 1), _c('li', {
    on: {
      "click": function($event) {
        _vm.clearSessionStrage()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('My Profile')))])])], 1), _c('li', {
    on: {
      "click": function($event) {
        _vm.clearSessionStrage()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/deadline_notices"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Deadline Notice')))]), _vm._v(" "), (_vm.noticeCount > 0) ? _c('span', {
    staticClass: "badge",
    staticStyle: {
      "background-color": "red"
    }
  }, [_vm._v(_vm._s(_vm.noticeCount))]) : _vm._e()])], 1), (_vm.isHumanStaff) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.clearSessionStrage()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/introduction"
    }
  }, [_c('i', {
    staticClass: "fa fa-handshake-o"
  }), _vm._v(" "), _c('span', [_vm._v("エントリー")]), _vm._v(" "), (_vm.introductionNoticeCount > 0) ? _c('span', {
    staticClass: "badge",
    staticStyle: {
      "background-color": "red"
    }
  }, [_vm._v(_vm._s(_vm.introductionNoticeCount))]) : _vm._e()])], 1) : _vm._e(), _c('li', {
    on: {
      "click": function($event) {
        _vm.clearSessionStrage()
      }
    }
  }, [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Logout')))])])])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-956ff7b0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app-header.pug
// module id = 870
// module chunks = 1